export const MODULE = {
  CUSTOMER: "Customer",
  INVENTORY: "Inventory",
  PPS: "PPS",
  LEADS:"Leads",
  DNA:"DNA",
  INTELLIGENCE: "IntelligenceHub",
  ENGAGE:"Engage",
};

export const ALLOWED_ACTION = {
  RIGHTS: "Rights",
  INFO_LEVEL: "InfoLevel",
};
